import { Request } from '../../Servidor/Request';

export class LaboratoryRequest {
    private sgeplaboratorio: number;
    private nome: string;

    constructor(sgeplaboratorio: number, nome: string) {
        this.sgeplaboratorio = sgeplaboratorio;
        this.nome = nome;
    }


    /**
     * Getter sgeplaboratorio
     * @return {number}
     */
    public getSgepLaboratorio(): number {
        return this.sgeplaboratorio;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class LaboratoryStructRequest {
    private sgeplaboratorio: number;

    constructor(sgeplaboratorio: number) {
        this.sgeplaboratorio = sgeplaboratorio;
    }


    /**
     * Getter sgeplaboratorio
     * @return {number}
     */
    public getSgepLaboratorio(): number {
        return this.sgeplaboratorio;
    }

}

export class LaboratoryStructResponse {
    private sgeplaboratorio: number;
    private nome: string;

    constructor(sgeplaboratorio: number, nome: string) {
        this.sgeplaboratorio = sgeplaboratorio;
        this.nome = nome;
    }


    /**
     * Getter sgeplaboratorio
     * @return {number}
     */
    public getSgepLaboratorio(): number {
        return this.sgeplaboratorio;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class LaboratoryInteractor {
    public fetchSave(request: LaboratoryRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/laboratorio/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: LaboratoryStructRequest): PromiseLike<LaboratoryStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/laboratorio/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}